export enum ThankYouType {
  URL = 'URL',
  PAGE = 'PAGE',
  RETURN = 'RETURN',
}
